import React, { useState } from 'react'
import { App, } from 'antd'
import { useKaipiaodanCWCHMutation, } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'   
import dayjs from 'dayjs'
function InvoiceFinanceWithdraw(props) {    
    const {message,modal} = App.useApp()
    const [cwch] = useKaipiaodanCWCHMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const content = props.kpsq_cw_content ? props.kpsq_cw_content + `！${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：开票申请取消提交` : `${dayjs().format('YYYY-MM-DD HH:mm:ss')} 财务操作：开票申请取消提交`
    const handleCWCH = () => {
        // 如果正在提交中，直接返回
        if (isSubmitting) {
            return;
        }
        
        // 设置提交状态
        setIsSubmitting(true);
        
       modal.confirm({
        title: '确认要取消这个开票申请的提交吗？',
        content: '财务取消提交后，开票申请将退回到待提交状态，计调修改后重新提交。',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
            cwch({
                kpsq_id:props.kpsq_id,
                kpsq_state: '1',
                kpsq_cw_content:content,
                kpsq_amount:props.kpsq_amount,
            }).then((res) => {
                if(res.data.Status === 'success') {
                    message.success('开票申请取消提交成功！')
                if (props.onSuccess && typeof props.onSuccess === 'function') {
                    props.onSuccess();
                }
                }else{
                    message.error('开票申请取消提交失败！'+res.data.Message)
                }
                // 3秒后恢复可点击状态
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
            }).catch((err) => {
                // 出错时也要恢复状态
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
            })
        },
        onCancel: () => {
            setIsSubmitting(false);
        }
       })
    }    
    return (
        <Icon 
            type='withdraw' 
            onClick={() => handleCWCH()} 
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        />
    )
}

export default InvoiceFinanceWithdraw